import styled from 'styled-components';
import COLORS from 'shared/constants/colors';

const Container = styled.div``;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  img {
    width: 200px;
    display: block;
    margin: 15px 0;
  }
  h4 {
    font-size: 19px;
    margin-top: 0;
  }
  Button {
    border-radius: 20px;
    padding: 0.5em 1em;
    background: #000;
  }
`;
const FieldsGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 15px;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  > div {
    margin-bottom: 15px;
    @media (max-width: 435px) {
      :nth-child(4) {
        grid-template-columns: 1fr;
        grid-gap: 15px;
      }
    }
  }
  p {
    margin-bottom: 0;
  }

  button {
    background-color: ${COLORS.BLACK};
    font-size: 15px;
    border-radius: 50px;
    padding: 8px 12px;
    line-height: 1.5;
    color: ${COLORS.WHITE};
    font-weight: 700;
    :hover {
      background-color: ${COLORS.BLACK};
    }
  }
`;

const CreateAccount = styled.a`
  font-size: 15px;
  color: #272742;
  text-decoration: underline;
  margin-top: 5px;
  cursor: pointer;
  &:hover {
    color: #ccc;
  }
`;
const ForgetPassword = styled.a`
  padding: 15px 0;
  color: #000;
  cursor: pointer;
  width: fit-content;
  margin: 0 auto;
  text-decoration: underline;
  font-size: 15px;
  &:hover {
    color: #ccc;
  }
`;
const Footer = styled.div`
  border-top: 1px solid #ccc;
  display: flex;
  justify-content: space-between;
  padding-top: 1em;
  color: ${COLORS.BLACK};
  font-size: 15px;
  margin-top: 15px;
  cursor: pointer;
  &:hover {
    color: #ccc;
  }
  p {
    margin: 0;
  }
`;
const Column = styled.div`
  display: grid;
  grid-gap: 20px;
  width: 100%;
  @media (min-width: 768px) {
    grid-template-columns: 2fr 1fr;
  }
`;
const Fields = styled.div`
  padding: 15px;
`;
const Description = styled.div`
  background: url('https://bigoventees.com/img/chooseUs.png');
  background-size: cover;
  background-repeat: no-repeat;
  padding: 15px;
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  color: #fff;
  h4 {
    margin: 0;
    font-size: 19px;
    margin-bottom: 7px;
  }
  p {
    font-size: 15px;
    font-weight: 700;
    margin-top: 0;
  }
`;

const Terms = styled.div`
  display: flex;
  align-items: center;
  p {
    margin: 0;
    margin-left: -10px;
    font-size: 1rem;

    font-weight: 400;
    line-height: 1.5;
    letter-spacing: 0.00938em;

    span {
      cursor: pointer;
      text-decoration: underline;
    }
  }
`;

export {
  Container,
  Header,
  Body,
  CreateAccount,
  ForgetPassword,
  Footer,
  Column,
  Fields,
  Description,
  Terms,
  FieldsGroup,
};
